import {
  createCornerTurnLabel3d,
  billboardCornerLabel,
} from './cornerTurnLabel3d.js';

export function cornerKeyFromT(t) {
  return t.toFixed(4);
}

/**
 * @param {string} name
 * @param {number} index
 */
export function formatCornerLabelContent(name, index) {
  return name.trim().toUpperCase() || 'MARKER NAME';
}

/**
 * @param {{ setContent: (title: string) => void }} label
 * @param {string} name
 * @param {number} index
 */
export function setCornerLabelContent(label, name, index) {
  label.setContent(formatCornerLabelContent(name, index));
}

/**
 * In-scene turn label (Three.js geometry + billboard text).
 */
export function createMapCornerLabel() {
  const label = createCornerTurnLabel3d();
  label.object.visible = false;

  return {
    object: label.object,
    setContent: label.setContent.bind(label),
    setScale: label.setScale.bind(label),
    dispose: label.dispose.bind(label),
  };
}

export { billboardCornerLabel };

/**
 * @param {THREE.Object3D} object
 * @param {THREE.Object3D[]} markerRoots
 */
export function findCornerMarkerRoot(object, markerRoots) {
  let current = object;
  while (current) {
    if (markerRoots.includes(current)) return current;
    current = current.parent;
  }
  return null;
}

/**
 * @param {MouseEvent} event
 * @param {HTMLCanvasElement} canvas
 * @param {THREE.Camera} camera
 * @param {THREE.Raycaster} raycaster
 * @param {THREE.Vector2} pointerNdc
 * @param {THREE.Object3D[]} markerRoots
 */
export function pickCornerMarkerFromEvent(
  event,
  canvas,
  camera,
  raycaster,
  pointerNdc,
  markerRoots,
) {
  if (markerRoots.length === 0) return null;

  const rect = canvas.getBoundingClientRect();
  pointerNdc.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
  pointerNdc.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;

  raycaster.setFromCamera(pointerNdc, camera);
  const hits = raycaster.intersectObjects(markerRoots, true);
  if (hits.length === 0) return null;

  return findCornerMarkerRoot(hits[0].object, markerRoots);
}
